if(!customElements.get('announcements-bar')) {
  customElements.define(
    'announcements-bar',
    class AnnouncementsBar extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;
      #sliderPrevEl = undefined;
      #sliderNextEl = undefined;
      #sliderPaginationEl = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          return console.error('[Slider] No slider element was found.')
        }

        this.#sliderInstance = new Swiper(this.#sliderEl, {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          speed: 3000,
          slidesPerView: 1,
          spaceBetween: 0,
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  )
}